function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import React, { useCallback, useContext } from 'react';
import { Select } from '@tapresearch/ui/components';
import { filterContext } from '../FilterProvider';
export function FilterSelect(_param) {
    var _param_onChange = _param.onChange, onChange = _param_onChange === void 0 ? function() {
    /* do nothing*/ } : _param_onChange, name = _param.name, children = _param.children, rest = _object_without_properties(_param, [
        "onChange",
        "name",
        "children"
    ]);
    var context = useContext(filterContext);
    var defaultValue = context.getDefaultValueByName(name) || '';
    var innerOnChange = useCallback(function(e) {
        var _e_target = e.target, innerValue = _e_target.value;
        var label = e.target.querySelector('option[value="'.concat(innerValue, '"]')).textContent;
        onChange(name, innerValue, label);
        context.onFilterItemChange(name, innerValue, label);
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        onChange,
        name
    ]);
    return /*#__PURE__*/ React.createElement(Select, _object_spread_props(_object_spread({}, rest), {
        onChange: innerOnChange,
        defaultValue: defaultValue
    }), children);
}
